var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChannel = function SvgChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeWidth: 1.5,
    d: "M15 1h-4c-2.828 0-4.243 0-5.121.946C5 2.893 5 4.416 5 7.462v1.076c0 3.047 0 4.57.879 5.516C6.757 15 8.172 15 11 15h4c2.828 0 4.243 0 5.121-.946.879-.947.879-2.47.879-5.516V7.462c0-3.046 0-4.57-.879-5.516C19.243 1 17.828 1 15 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeWidth: 1.5,
    d: "M17 15.608c-.012 2.346-.109 3.616-.877 4.444-.879.948-2.293.948-5.122.948h-4c-2.83 0-4.243 0-5.122-.948C1 19.106 1 17.58 1 14.53v-1.078c0-3.05 0-4.576.879-5.523C2.52 7.237 3.447 7.05 5 7"
  })));
};
export default SvgChannel;